import React from "react"
import { DrawerProvider } from "./drawer";
import { ModalProvider } from "./modal";
import RTLProvider from "../config/RTLProvider";
import theme from "../config/theme";
import { ThemeProvider } from "@mui/material/styles";
import { ToastProvider } from "./toast";
// import AxiosProvider from "./axios";

export default function ContextProvider({ children }) {
  return (
    <ThemeProvider theme={theme}>
      <RTLProvider>
        <DrawerProvider>
          <ModalProvider>
            <ToastProvider>
              {/* <AxiosProvider> */}
              {children}
              {/* </AxiosProvider> */}
            </ToastProvider>
          </ModalProvider>
        </DrawerProvider>
      </RTLProvider>
    </ThemeProvider>
  )

}
